import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AOS from "aos";
import "./ScrollToTop.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (AOS.refreshHard) {
      AOS.refreshHard();
      return;
    }

    if (AOS.refresh) {
      AOS.refresh();
    }
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 260);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <button
      type="button"
      className={`scroll-top-button${isVisible ? " scroll-top-button--visible" : ""}`}
      onClick={() => window.scrollTo(0, 0)}
      aria-label="Scroll to top"
    >
      <span  style={{color:"white"}} className="scroll-top-button__arrow">↑</span>
    </button>
  );
}

export default ScrollToTop;
